import { useQuery } from '@tanstack/react-query';
import { invitationsService } from '../api/invitations.service';
import { MY_INVITATIONS_KEYS } from './queryKeys';

/**
 * Resolves public invitation details by token (email-link flow).
 *
 * @remarks
 * - `staleTime: 0`: the token's validity can change server-side at any moment.
 * - `enabled: !!token`: skips the request when no token is present in the URL.
 * - The endpoint requires `X-Tenant-Id`; the active organization in session is
 *   injected automatically by httpClient.
 */
export function useInvitationByToken(token: string) {
  return useQuery({
    queryKey: MY_INVITATIONS_KEYS.byToken(token),
    queryFn: ({ signal }) => invitationsService.getInvitationByToken(token, signal),
    staleTime: 0,
    enabled: !!token,
  });
}
